import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Store from '../../index'
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp, setVersionList, setTabGridLabel } from '../../GlobalModules/Login/Actions/LoginAction'; // for control pannel added
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import '../../Home/Assets/css/homedoc.scss';
import '../../Home/Assets/css/homeresponsivedoc.scss';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import Worker from '../Components/Worker/Worker';
import Organization from '../Components/Organization/Organization';
import AccountInfo from '../Components/AccountInfo/AccountInfo';
import UserGroup from '../Components/GroupManagement/UserGroup/UserGroup';
import ModalGlobal from '../../Utility/Components/ModalGlobal';
import ConfirmationAlert from '../../Utility/Components/ConfirmationAlert';
import * as LoginController from '../../GlobalModules/Login/Controller/LoginController';
import Dashboard from '../Components/Dashboard/Dashboard';
import LoginActivity from '../Components/LoginActivity/LoginActivity';
import SupportUser from '../../GlobalModules/SupportUser/SupportUser';
import UtilityGlobal from '../../GlobalModules/Utility/Utility';
import { EventEmitter } from '../../Utility/EventEmitter';



// import Config from '../../../Utility/Config'
// import Utility from '../../../Utility/Utility';

class HomePage extends Component {
     
    constructor(props) {
        super(props);
        this.state = {
            // selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "worker",
            // selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "dashboard",
            selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "tabIdx_0", // for control pannel added
            //selectedTabName: "worker",
            tabcontainerspace: "",
            tabchangeParent: false,
            tabChangeConfirmModal: false,
            tempTabName: "",
            loginActivitiesPermissionTab: false,
            accountInfoPermissiontab: false,
            appUserPermissionTab: false,
            dashboardTabPermissionTab: false

        }
    }
    componentDidMount() {
        this.props.handleActiveLink("home_module", "");
        this.permissionWiseTabSelected();
        // if (this.props.userCredentials?.user_details?.user_type == 'app_admin') {
        this.getVersionListFn();
        // if (this.props.userCredentials?.user_details?.user_type != 'app_admin') {
        //     this.loadTabAndGridLabel(); // for control pannel added
        // }
        // } 
        // console.log("localStorage========", localStorage.getItem("selectedTabName"))
        //this.connectToWebSocketApi()
        this.firstTimeSelectedTab()
        this.checkTabRole()
        if (localStorage.getItem("selectedTabName") == "dashboardTab") {
            this.setState({
                selectedTabName: `tabIdx_0`
            })
        }
    }

    checkTabRole = async () => {
        const dashboardTabPermission = await UtilityGlobal.getRoleObjectBySubEventKey('home', 'dashboard');
        const appUserPermission = await UtilityGlobal.getRoleObjectBySubEventKey('home', 'appUser');
        const accountInfoPermission = await UtilityGlobal.getRoleObjectBySubEventKey('home', 'accountInfo');
        const loginActivitiesPermission = await UtilityGlobal.getRoleObjectBySubEventKey('home', 'loginActivities');

        if (loginActivitiesPermission.length > 0) {
            this.setState({
                loginActivitiesPermissionTab: true
            })
        }

        if (accountInfoPermission.length > 0) {
            this.setState({
                accountInfoPermissionTab: true
            })
        }

        if (appUserPermission.length > 0) {
            this.setState({
                appUserPermissionTab: true
            })
        }

        if (dashboardTabPermission.length > 0) {
            this.setState({
                dashboardTabPermissionTab: true
            })
        }
    }

    getVersionListFn = async () => {
        //console.log('enry=================>')
        let data = {};
        loaderStateTrue();
        LoginController.getVersionList(data).then((response) => {
            let versionList = [];
            let versionListObj = {};
            response.data.map((e) => {
                versionListObj = {};
                versionListObj['label'] = `${e.version} ( ${e.description} )`;
                versionListObj['value'] = e.id;
                versionListObj['user_count'] = e.user_count,
                versionListObj['message_count'] = e.message_count,
                versionList.push(versionListObj)
            })
            // console.log('version list dataset------------>', versionList)
            if (versionList.length > 0) {
                this.props.setVersionList(versionList);
            }

            //console.log('global state**********',globalState)
            loaderStateFalse();
            //props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    //for control pannel added
    /* loadTabAndGridLabel = () => {
        let header = {};
        header["Authorization"] = Store.default.getState().LoginReducer.token;
        loaderStateTrue();
        LoginController.getAllTabGridLable({ headers: header }).then((response) => {
            // console.log("response===========", response)
            if (response.success) {
                const parseResponseData = response.data.map(item => {
                    return {
                        ...item,
                        setting_data: JSON.parse(item.setting_data)
                    };
                });
                console.log("parseResponseData===========", parseResponseData)
                // this.props.setTabGridLabel(response.data)
                this.props.setTabGridLabel(parseResponseData)
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    } */
    //end

    //Socket
    // connectToWebSocketApi = () => {
    // 	const { connectToWebsocket } = this.props;
    // 	let email = 'app.admin@cal.com';
    // 	let id = 1;
    // 	connectToWebsocket(email, id).then(() => {
    // 		this.reciveMessagesUsingWebsocket();
    // 	})

    // }
    // componentWillUnmount() {
    // 	const { disconnectToWebsocket, websocket } = this.props;
    // 	disconnectToWebsocket(websocket)
    // }

    // reciveMessagesUsingWebsocket = () => {
    // 	//alert(1)
    // 	const { websocket } = this.props;

    // 	//if (websocket) {
    // 	// alert();
    // 	websocket.onmessage = (evt) => {
    // 		var receivedMsg = evt.data;
    // 		console.log("received_msg", receivedMsg)
    // 		Utility.toastNotifications(receivedMsg, "Success", "success");
    // 		alert("Message is received...");
    // 	};
    // 	//console.log("websocket", websocket)
    // 	websocket.onclose = e => {
    // 		// alert(222222222222222222222222222222222222222222222222222222222222222222222222222222222222);           
    // 		//  setTimeout(()=>{
    // 		//this.check()
    // 		// },1000)
    // 		// that.timeout = that.timeout + that.timeout; //increment retry interval
    // 		//connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
    // 	};
    // 	/* websocket.onclose = (event) => {
    // 		 connectToWebsocket()
    // 		 alert();
    // 		 console.log("WebSocket is closed now.");
    // 	 };*/
    // 	//}

    // }
    // check = () => {
    // 	const { websocket, connectToWebsocket, userCredentials } = this.props;
    // 	if (!websocket || websocket.readyState == WebSocket.CLOSED) connectToWebsocket(userCredentials); //check if websocket instance is closed, if so call `connect` function.
    // };

    //Socket finish		
    setTabConatinerSpaceClass = (className) => {
        this.setState({
            tabcontainerspace: className
        })

    }

    detectChangesIndividualTab = (value = false) => {
        this.setState({
            tabchangeParent: value
        })

    }


    openTabChangeConfirmModal = () => {
        this.setState({
            tabChangeConfirmModal: true
        })
    }
    tabChangeConfirmModalHide = () => {
        this.setState({
            tabChangeConfirmModal: false,
            tempTabName: ""
        })
    }


    handelSelectTab = async (tabName) => {
        if (this.state.tabchangeParent == true) {
            this.setState({
                tempTabName: tabName
            }, () => {
                this.openTabChangeConfirmModal()
                //for confirmation modal hide every tab change (24.02.2023)
                this.confirmTabChange()
                localStorage.setItem("selectedTabName", tabName);
            })
        } else {
            this.setState({
                selectedTabName: tabName
            }, () => {
                localStorage.setItem("selectedTabName", tabName);
            })
        }
    }
    confirmTabChange = () => {
        this.setState({
            selectedTabName: this.state.tempTabName
        }, () => {
            this.cancelTabChange()
            this.setState({
                tabchangeParent: false
            })
        })
    }
    cancelTabChange = () => {
        this.tabChangeConfirmModalHide()
    }

    permissionWiseTabSelected = () => {
        const { roleWisePermission } = this.props;
        if (this.props.match.params.type) {
            this.setState({
                selectedTabName: this.props.match.params.type
            })
        } else {
            // if (Object.keys(roleWisePermission) && Object.keys(roleWisePermission).length > 0) {
            //let tab_order = ["worker"];
            //let first_tab = Object.keys(roleWisePermission).filter((x) => tab_order.includes(x))[0];
            //let first_tab = tab_order.filter((x) => Object.keys(roleWisePermission).includes(x))[0];
            this.setState({
                // selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "worker"
                // selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "dashboard"
                selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : "tabIdx_0" // for control pannel added
            })
            //}
        }
    }

    validationPermission = (eventKey) => {
        const { t, roleWisePermission } = this.props;
        let valid = false;
        if (roleWisePermission.hasOwnProperty(eventKey) && roleWisePermission[eventKey].read_write_permission != "") {
            valid = true;
        }
        return valid
    }

    // for control pannel added
    gridLabledata = () => {
        const { tabGridLabel } = this.props;
        const grid_dataset = tabGridLabel?.filter(item => item.ui_element_type.includes("grid") && item.uniq_identifier == "user_activity_grid" && item.screen_name == "home");
        // console.log("grid_dataset=========", grid_dataset)
        return grid_dataset;
    }

    tabUi = (val, idx) => {
        // console.log("val=========", val)
        const { t, roleWisePermission, userCredentials } = this.props;
        let arryHash = roleWisePermission;
        let arry = []
        let roleName = userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type;
        // console.log('role------->', roleName)

        let version = userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('version') && userCredentials.user_details.version

        const tabComponentsAdmin = {
            dashboard: Dashboard,
            group: UserGroup,
            accountInfo: AccountInfo,
            loginActivityDetails: LoginActivity,
        };
        // const tabComponentsAppAdmin = {
        //     worker: Worker,
        //     organization: Organization,
        // };

        if (version != "v1" && roleName != "app_admin") {
            arry.push(
                <Tab eventKey={`tabIdx_${idx}`} title={val.modified_field_caption} key={idx}>
                    {this.state.selectedTabName == `tabIdx_${idx}` && (
                        (() => {
                            const TabComponentAdmin = tabComponentsAdmin[val.field_name];
                            return TabComponentAdmin ? (
                                <TabComponentAdmin
                                    setTabConatinerSpaceClass={this.setTabConatinerSpaceClass}
                                    detectChangesIndividualTab={this.detectChangesIndividualTab}
                                    gridLableData={this.gridLabledata()}
                                />
                            ) : null;
                        })()
                    )}
                </Tab>
            )
        } else {
            /* arry.push(
                <Tab eventKey={`tabIdx_${idx}`} title={val.modified_field_caption != "" && val.modified_field_caption != null ? val.modified_field_caption : val.field_caption} key={idx}>
                    {this.state.selectedTabName == `tabIdx_${idx}` && (
                        (() => {
                            const TabComponentAppAdmin = tabComponentsAppAdmin[val.field_name];
                            return TabComponentAppAdmin ? (
                                <TabComponentAppAdmin
                                    setTabConatinerSpaceClass={this.setTabConatinerSpaceClass}
                                    detectChangesIndividualTab={this.detectChangesIndividualTab}
                                    gridLableData={this.gridLabledata()}
                                />
                            ) : null;
                        })()
                    )}
                </Tab>
            ) */
            arry.push(
                <Tab eventKey="tabIdx_0" title="Users" key={1}>
                    {this.state.selectedTabName == `tabIdx_0` ?
                        < Worker setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
            arry.push(
                <Tab eventKey="tabIdx_1" title={t('organization')} key={3}>
                    {this.state.selectedTabName == 'tabIdx_1' ?
                        < Organization setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
            arry.push(
                <Tab eventKey="tabIdx_2" title="Support User" key={4}>
                    {this.state.selectedTabName == 'tabIdx_2' ?
                        <SupportUser setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }
        return arry;
    }
    // end control pannel added

    /* tabUi = () => {
        const { t, roleWisePermission, userCredentials } = this.props;
        let arryHash = roleWisePermission;
        let arry = []

        let roleName = userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type
        let version = userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('version') && userCredentials.user_details.version

        if (version != "v1" && roleName != "app_admin") {
            arry.push(
                <Tab eventKey="dashboard" title="Dashboard" key={0}>
                    {this.state.selectedTabName == 'dashboard' ?
                        < Dashboard setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }
        if (version != "v1" && roleName == "app_admin") {
            arry.push(
                <Tab eventKey="worker" title="Users" key={1}>
                    {this.state.selectedTabName == 'worker' ?
                        < Worker setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }
        if (version != "v1" && roleName != "app_admin") {
            arry.push(
                <Tab eventKey="group" title={t('App Users')} key={2}>
                    {this.state.selectedTabName == 'group' ?
                        < UserGroup setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }
        if (roleName == "app_admin" && version != "v1") {
            // if (version != "v1") {
            arry.push(
                <Tab eventKey="organization" title={t('organization')} key={3}>
                    {this.state.selectedTabName == 'organization' ?
                        < Organization setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
                // <Tab eventKey="organization" title={roleName == "app_admin" ? t('organization') : t('accountInfo')} key={3}>
                //     {this.state.selectedTabName == 'organization' ?
                //         < Organization /> : null}
                // </Tab>
            )
        }
        if (roleName != "app_admin" && version != "v1") {
            arry.push(
                <Tab eventKey="accountInfo" title={t('accountInfo')} key={4}>
                    {this.state.selectedTabName == 'accountInfo' ?
                        < AccountInfo setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }
        if (roleName == "admin" && version != "v1") {
            arry.push(
                <Tab eventKey="loginActivityDetails" title={t('loginActivites')} key={5}>
                    {this.state.selectedTabName == 'loginActivityDetails' ?
                        < LoginActivity setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            )
        }


        return arry;

    } */

    firstTimeSelectedTab = () => {
        const { userCredentials } = this.props;
        let locationPath = this.props.history.location.pathname.split("/")
        let lastIndex = locationPath.length - 1
        let roleName = userCredentials.hasOwnProperty('user_details') && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type
        if (locationPath[lastIndex] == "home" && localStorage.getItem("selectedTabName") != "tabIdx_0" && localStorage.getItem("selectedTabName") == "organization") { // for control pannel added 
            this.setState({
                selectedTabName: "organization"
            }, () => {
                localStorage.setItem("selectedTabName", "organization")
            })
        } else {
            if (roleName != "app_admin") {
                if (localStorage.getItem("selectedTabName") == "tabIdx_0") { // for control pannel added
                    this.setState({
                        selectedTabName: "tabIdx_0" // for control pannel added
                    }, () => {
                        localStorage.setItem("selectedTabName", "tabIdx_0") // for control pannel added
                    })
                }
                if (localStorage.getItem("selectedTabName") == "fbMessageTemplate" || localStorage.getItem("selectedTabName") == "CampaignBroadcasting" || localStorage.getItem("selectedTabName") == "contactGroup") {
                    this.setState({
                        selectedTabName: "tabIdx_0" // for control pannel added
                    }, () => {
                        localStorage.setItem("selectedTabName", "tabIdx_0") // for control pannel added
                    })
                }
            } else {
                // for control pannel added
                if (localStorage.getItem("selectedTabName") == this.state.selectedTabName) {
                    // console.log("ifffffffff=======")
                    this.setState({
                        selectedTabName: this.state.selectedTabName
                    }, () => {
                        localStorage.setItem("selectedTabName", this.state.selectedTabName)
                    })
                } else {
                    // console.log("elseeeeeeeeeee=======")
                    this.setState({
                        selectedTabName: "tabIdx_0"
                    }, () => {
                        localStorage.setItem("selectedTabName", "tabIdx_0")
                    })
                }
                // end for control pannel added
            }
        }
    }

    render() {
        const { t, userCredentials, tabGridLabel } = this.props;  // for control pannel added
        // console.log("ttttttttttttt========", this.state.selectedTabName)
        const { tabcontainerspace } = this.state;
        // for control pannel added
        // const tabDataset = userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type == 'app_admin'
        //     ? tabGridLabel?.filter(item => item.ui_element_type.includes("tab") && item.screen_name.toLowerCase().includes("home") && ["worker", "organization"].includes(item.field_name)).map(item => ({ ...item, setting_data: item.setting_data.filter(val => val.current_status == 1) }))
        //     : tabGridLabel?.filter(item => item.ui_element_type.includes("tab") && item.screen_name.toLowerCase().includes("home") && !["worker", "organization"].includes(item.field_name)).map(item => ({ ...item, setting_data: item.setting_data.filter(val => val.current_status == 1) }));
        const tabDataset = userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type != 'app_admin' && tabGridLabel?.filter(item => item.ui_element_type.includes("tab") && item.uniq_identifier.includes("page_menu") && item.screen_name.toLowerCase().includes("home") && !["worker", "organization"].includes(item.field_name)).map(item => ({ ...item, setting_data: item.setting_data.filter(val => val.current_status == 1) }));
        const reorderedData = tabDataset?.length > 0 && tabDataset?.map((tab) => ({
            ...tab,
            setting_data: tab.setting_data.sort((a, b) => {
                if (a.field_name == 'dashboard') return -1;
                if (b.field_name == 'dashboard') return 1;
                return 0;
            })
        }));
        // const tabs_UI = tabDataset?.length > 0 && reorderedData && reorderedData[0].setting_data.map((val, idx) => this.tabUi(val, idx));
        const user_type = userCredentials?.user_details?.user_type;
        const tabs_UI = tabDataset?.length > 0 && reorderedData && reorderedData[0].setting_data
            .filter((val) => {
                // if (user_type == 'user' && (val.field_name === 'accountInfo' || val.field_name === 'loginActivityDetails')) {
                //     return false;
                // }
                if (user_type == 'user' && ((val.field_name == 'accountInfo' && !this.state.accountInfoPermissionTab) || 
                    (val.field_name == 'loginActivityDetails' && !this.state.loginActivitiesPermissionTab) || (val.field_name == 'group' && !this.state.appUserPermissionTab) || (val.field_name == 'dashboard' && !this.state.dashboardTabPermissionTab))) {
                    return false;  // Skip the tab if permission is false
                }
                return true;
            })
            .map((val, idx) => this.tabUi(val, idx));

        return (
            <div className={`${tabcontainerspace} homepagecontainer connectheader`} >
                <Tabs
                    id="homepagetabs"
                    activeKey={this.state.selectedTabName}
                    className="tabsmainbox"
                    onSelect={this.handelSelectTab}

                >
                    {/* {this.tabUi()} */}
                    {/* ========for control pannel added======= */}
                    {userCredentials.user_details.user_type != 'app_admin' ? tabs_UI : this.tabUi()}
                    {/* =======end======== */}
                </Tabs>
                <ModalGlobal
                    show={this.state.tabChangeConfirmModal}
                    onHide={this.tabChangeConfirmModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title=""
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent={t('navigateConfirmation')}
                            BodySecondContent=""
                            BodyThirdContent=""
                            confirmationButtonContent={t('confirm')}
                            cancelButtonContent={t('cancel')}
                            deleteConfirmButton={this.confirmTabChange}
                            deleteCancleButton={this.cancelTabChange}
                        />
                    }
                />
            </div >
        );
    }
}




const mapStateToProps = (globalState) => {
    //console.log("globalState===", globalState)
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        websocket: globalState.mainReducerData.websocket,
        tabGridLabel: globalState.LoginReducer.tabGridLabel, // for control pannel added
    };
}


export default withRouter(connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, setVersionList, logOutApp, connectToWebsocket, disconnectToWebsocket, setTabGridLabel })
    (withTranslation()(HomePage))); // for control pannel added